// Matches the `sm` breakpoint, so these gates agree with the phone-only CSS media queries.
const PHONE_QUERY = '(max-width: 39.99em)';

/** One-shot phone check. False off-browser, so nothing gets disabled in server or test contexts. */
export default function isPhone(): boolean {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') {
    return false;
  }

  return window.matchMedia(PHONE_QUERY).matches;
}
